import type React from 'react';
import { useTranslation } from 'react-i18next';

type MeasurementProps = {
  value: number | null | undefined;
  unit: string | null | undefined;
  translationKey: string;
};

export const Measurement: React.FC<MeasurementProps> = ({ value, unit, translationKey }) => {
  const { t } = useTranslation();

  if (value === null || value === undefined) {
    return null;
  }

  const displayText = `${value}${unit ? ` ${unit}` : ''}`;

  return (
    <div className="flex gap-2">
      <span className="font-bold">{t(translationKey)}:</span>
      <span>{displayText}</span>
    </div>
  );
};
